// extracted by mini-css-extract-plugin
export var actions = "_t9-4";
export var item = "_t9-1";
export var price = "_t9-3";
export var quantity = "_t9-2";
export var table = "_t9-0";